import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import roTranslations from './locales/ro.json';
import ruTranslations from './locales/ru.json';
import { enChat, roChat, ruChat } from './chatTranslations';
import { enImport, roImport, ruImport } from './importTranslations';
import { enDailySales, roDailySales, ruDailySales } from './dailySalesTranslations';

i18n
  .use(LanguageDetector) // Automatically detect user language
  .use(initReactI18next) // Initialize react-i18next
  .init({
    // Define available languages and their translations
    resources: {
      en: {
        translation: { ...enTranslations, chat: enChat, import: enImport, dailySales: enDailySales }
      },
      ro: {
        translation: { ...roTranslations, chat: roChat, import: roImport, dailySales: roDailySales }
      },
      ru: {
        translation: { ...ruTranslations, chat: ruChat, import: ruImport, dailySales: ruDailySales }
      }
    },
    
    // Set default language
    fallbackLng: 'en',
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    
    // Enable interpolation
    interpolation: {
      escapeValue: false // React already escapes by default
    },
    
    // Debug mode (disable in production)
    debug: process.env.NODE_ENV === 'development'
  });

export default i18n;
